export function filterTicketsByRole(tickets, userId, userRole) {
  if (userRole === "admin") {
    return tickets; // admin sees everything
  }

  // Non-admin users
  return tickets.filter((ticket) => {
    const isRaisedBy = ticket.raisedBy === userId;
    const isAssignedTo = (ticket.assignedUsers || []).includes(userId);
    return isRaisedBy || isAssignedTo;
  });
}
